import Joi from'joi';var emptyTemplate = 'shared.validation.empty';
var validEmailTemplate = 'shared.email.validation.email';
var USERNAME_MIN_LENGTH = 6;
var USERNAME_MAX_LENGTH = 254;
var PASSWORD_MIN_LENGTH = 8;
var PASSWORD_MAX_LENGTH = 64;
var escapeRegexpInString = function escapeRegexpInString(string) {
  if (typeof string !== 'string') {
    throw new TypeError('Expected a string');
  }
  return string.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
};

// Reusuable base rules
var hasLowerCase = Joi.string().regex(/[a-z]+/, {
  name: 'hasLowerCase'
});
var hasUpperCase = Joi.string().regex(/[A-Z]+/, {
  name: 'hasUpperCase'
});
var hasNumber = Joi.string().regex(/[0-9]+/, {
  name: 'hasNumber'
});
var hasNoPeriodFollowedByCharacter = Joi.string().regex(/\.\S/, {
  name: 'hasNoPeriodFollowedByCharacter',
  invert: true
});
var validFirstAndLastNameSpecialCharacters = Joi.string().regex(
// eslint-disable-next-line no-useless-escape
/^[\w'\-,.À-ÿ][^0-9_!¡?÷?¿/+=@#$%\^&*(){}|~<>;:[\]]{1,}$/, {
  name: 'validFirstAndLastNameSpecialCharacters'
});
var validPasswordSpecialCharacters = Joi.string().regex(
// eslint-disable-next-line no-useless-escape
/[\!"#\$%&\(\)\*\+\-\.\/\:;\<\=\>\?@\[\\\]\^\{\|\}\_]+/, {
  name: 'validPasswordSpecialCharacters'
});
var passwordHasNoInvalidCharacters = Joi.string().regex(
// eslint-disable-next-line no-useless-escape
/^[a-zA-Z0-9\!"#\$%&\(\)\*\+\-\.\/\:;\<\=\>\?@\[\\\]\^\{\|\}_]*$/, {
  name: 'passwordHasNoInvalidCharacters'
});
var validUsernameSpecialCharacters = Joi.string().regex(
// eslint-disable-next-line no-useless-escape
/^[a-zA-Z0-9#\$%+\-\/=\?\^_`\{\|\}~;@\. ]*$/, {
  name: 'validUsernameSpecialCharacters'
});
var hasDotAsFirstOrLast = Joi.string().ruleset.regex(/^\./, {
  invert: true
}).regex(/\.$/, {
  invert: true
}).messages();
var hasSpace = Joi.string().regex(/^[^ ]+$/);

// Field specific rules (usually a combination of the above)
var validUsername = Joi.string().concat(hasSpace.message('shared.username.checklist.noSpace')).min(USERNAME_MIN_LENGTH).max(USERNAME_MAX_LENGTH).concat(hasDotAsFirstOrLast.message('shared.username.checklist.noDotAsFirstLast')).concat(validUsernameSpecialCharacters.message('shared.username.checklist.hasNoInvalidCharacters')).messages({
  'string.empty': emptyTemplate,
  'string.min': 'shared.username.checklist.minMax',
  'string.max': 'shared.username.checklist.minMax'
});
var hasNoFirstLastName = function hasNoFirstLastName(firstName, lastName) {
  var reg1 = new RegExp("^.*".concat(firstName, "|").concat(lastName, ".*$"), 'i');
  return Joi.string().regex(reg1, {
    invert: true
  }, {
    name: 'passwordHasNoInvalidCharacters'
  });
};
var hasNoUserName = function hasNoUserName(userName) {
  var escapedUserName;
  if (userName && userName.trim().length !== 0) {
    escapedUserName = escapeRegexpInString(userName);
  }
  var reg = new RegExp("^.*".concat(escapedUserName, ".*$"), 'i');
  return Joi.string().regex(reg, {
    invert: true
  }, {
    name: 'passwordHasNoUserName'
  });
};
var hasUpperLowerCase = Joi.string().regex(/(?=.*[A-Z])(?=.*[a-z])+/, {
  name: 'hasUpperLowerCase'
});
var validPassword = function validPassword(data) {
  return Joi.string().concat(hasSpace.message('shared.password.checklist.noSpace')).min(PASSWORD_MIN_LENGTH).max(PASSWORD_MAX_LENGTH).concat(hasNoFirstLastName(data.firstName, data.lastName).message('shared.password.checklist.firstNameLastName')).concat(hasNoUserName(data.userName).message('shared.password.checklist.userName')).concat(hasUpperLowerCase.message('shared.password.checklist.upperLowerCase')).concat(hasNumber.message('shared.password.checklist.number')).concat(passwordHasNoInvalidCharacters.message('shared.password.checklist.invalidChar')).messages({
    'string.min': 'shared.password.checklist.minMax',
    'string.max': 'shared.password.checklist.minMax',
    'string.empty': 'shared.validation.empty'
  });
};
var validEmail = Joi.string().trim().email({
  tlds: false
}).messages({
  'string.empty': emptyTemplate,
  'string.email': validEmailTemplate
});
var validPrimaryEmail = function validPrimaryEmail(backupEmail) {
  return Joi.string().trim().email({
    tlds: false
  }).invalid(backupEmail).messages({
    'string.empty': emptyTemplate,
    'string.email': validEmailTemplate,
    'any.invalid': 'shared.email.validation.backupEmail'
  });
};
var validBackupEmail = function validBackupEmail(primaryEmail) {
  return Joi.string().trim().email({
    tlds: false
  }).invalid(primaryEmail).messages({
    'string.empty': emptyTemplate,
    'string.email': validEmailTemplate,
    'any.invalid': 'shared.email.validation.primaryEmail'
  });
};
var validName = Joi.string().trim().required().messages({
  'string.empty': emptyTemplate
});
var validFirstName = Joi.string().trim().required().concat(hasNoPeriodFollowedByCharacter.message('shared.Name.validation.hasPeriodFollowedByCharacter')).concat(validFirstAndLastNameSpecialCharacters.message('shared.firstName.validation.hasInvalidCharacters')).messages({
  'string.empty': emptyTemplate
});
var validLastName = Joi.string().trim().required().concat(hasNoPeriodFollowedByCharacter.message('shared.Name.validation.hasPeriodFollowedByCharacter')).concat(validFirstAndLastNameSpecialCharacters.message('shared.lastName.validation.hasInvalidCharacters')).messages({
  'string.empty': emptyTemplate
});
var validIsRequired = Joi.string().trim().required().messages({
  'string.empty': emptyTemplate
});
var validMUXMobileNumber = Joi.string().required().regex(/^[+]?[0-9]{1,3}?[\s][(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/).message('shared.muxMobileNumber.validation.empty').messages({
  'string.empty': 'shared.muxMobileNumber.validation.empty'
});
var validOTPCode = Joi.string().regex(/^[0-9]{6}$/).message('shared.otpcode.validation.empty').messages({
  'string.empty': 'shared.otpcode.validation.empty'
});
var dateOfBirthDayValidations = Joi.number().required().messages({
  'any.required': 'shared.dateofbirth.validation.day',
  'number.base': 'shared.dateofbirth.validation.day'
});
var dateOfBirthMonthValidations = Joi.string().required().messages({
  'any.required': 'shared.dateofbirth.validation.month',
  'number.base': 'shared.dateofbirth.validation.month'
});
var dateOfBirthYearValidations = Joi.number().required().messages({
  'any.required': 'shared.dateofbirth.validation.year',
  'number.base': 'shared.dateofbirth.validation.year'
});
var validPhoneOrEmail = Joi.alternatives().try(validMUXMobileNumber, validEmail).required().messages({
  'alternatives.match': 'shared.forgotusername.phoneOrEmail.validation'
});export{dateOfBirthDayValidations,dateOfBirthMonthValidations,dateOfBirthYearValidations,hasDotAsFirstOrLast,hasLowerCase,hasNoFirstLastName,hasNoPeriodFollowedByCharacter,hasNoUserName,hasNumber,hasSpace,hasUpperCase,hasUpperLowerCase,passwordHasNoInvalidCharacters,validBackupEmail,validEmail,validFirstAndLastNameSpecialCharacters,validFirstName,validIsRequired,validLastName,validMUXMobileNumber,validName,validOTPCode,validPassword,validPasswordSpecialCharacters,validPhoneOrEmail,validPrimaryEmail,validUsername,validUsernameSpecialCharacters};